<template>
  <div :class="['v-adsense']">
    <div :class="messageClass" :hidden="adSeverity === 'off'" :data-ad-severity="adSeverity">
      <div :style="{width: `${adBlockDetectedMessageWidth}px`}" v-if="adSeverity === 'block'" v-html="text" />
      <div v-if="['bar', 'message'].indexOf(adSeverity) > -1" v-html="text" />
    </div>
    <ins
      :class="['adsbygoogle']"
      :style="adStyle"
      :data-ad-client="adClient"
      :data-ad-slot="adSlot"
      :data-ad-format="adFormat" />
  </div>
</template>
<script>
// data-ad-layout "in-article" should render an additional attribute
// data-ad-layout-key="-8i+1w-dq+e9+ft" is for in-feed ads
export default {
  name: 'VueAdsense',
  data () {
    return {
      detected: 'v-adsense-ad-block-detected',
      text: 'This website is made possible by displaying online advertisements to the visitors. To view the content, please, disable your ad blocker then reload the page.',
      messageClass: ['v-adsense-ad-block-detected'],
      adSeverity: this.$attrs['ad-severity'] || 'off' // 'block', 'bar', 'message', 'off'
    }
  },
  props: {
    adBlockDetectedMessageWidth: {
      type: String,
      required: false,
      default: '300'
    },
    adLayout: {
      type: String,
      required: false,
      default: 'in-article'
    },
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'off' // 'fluid', 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    }
  },
  mounted () {
    this.check()
  },
  methods: {
    check () {
      if (document.getElementById('XuQnsBExZmfq')) {
        this.adSeverity = 'off'
        return (window.adsbygoogle = window.adsbygoogle || []).push({})
      }
    }
  }
}
</script>
<style>
.v-adsense [hidden]
{
  display: none;
}

.v-adsense [data-ad-severity]
{
  font: normal 14px/20px Helvetica, Arial, "Helvetica Neue", Helvetica, sans-serif;
  color: #777;
  cursor: default;
  user-select: none;
  z-index: 10000;
}

.v-adsense [data-ad-severity='block']
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
}

.v-adsense [data-ad-severity='block'] > div
{
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  transform: translate(-50%, -50%);
  padding: 1em;
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2),
              0 12px 17px 2px rgba(0, 0, 0, .14),
              0 5px 22px 4px rgba(0 ,0 , 0, .12);
}

.v-adsense [data-ad-severity="bar"]
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #b00;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .5);
}

.v-adsense [data-ad-severity='bar'] > div
{
  color: #fff;
  padding: 1em;
  text-align: center;
}

.v-adsense [data-ad-severity="message"]
{
  color: #b00;
}
</style>



// WEBPACK FOOTER //
// src/vendor-components/v-adsense/v-adsense.vue